import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import PostItem from "~components/post-item";
import { Container, Heading, Text, VStack } from "@chakra-ui/react";
import NextLink from "next/link";
import { NextSeo } from "next-seo";
var pageMeta = {
  title: "Blog posts",
  description: "Sometimes I write about web development, other times about random interesting stuff."
};

var BlogPostsPage = function BlogPostsPage(props) {
  var posts = props.posts;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NextSeo, _objectSpread({}, pageMeta)), /*#__PURE__*/_jsx(Container, {
      maxW: "4xl",
      p: [4, 8],
      children: /*#__PURE__*/_jsxs(VStack, {
        spacing: 4,
        textAlign: "center",
        children: [/*#__PURE__*/_jsx(Heading, {
          children: pageMeta.title
        }), /*#__PURE__*/_jsx(Text, {
          pb: 8,
          children: pageMeta.description
        }), /*#__PURE__*/_jsx(VStack, {
          spacing: 16,
          children: posts.map(function (post) {
            return /*#__PURE__*/_jsx(NextLink, {
              href: "/blog/".concat(post.slug),
              passHref: true,
              children: /*#__PURE__*/_jsx(PostItem, {
                post: post
              })
            }, post.slug);
          })
        })]
      })
    })]
  });
};

export var __N_SSG = true;
export default BlogPostsPage;